import * as React from 'react';
import ReactDOM from 'react-dom';
import { Overlay } from './style.css';

const OverlayPortalTargetSelector = '#root';

/* Interfaces */
interface OverlayComponentProps {
  backgroundColor?: string;
  close?: () => void;
  closeOnClick?: boolean;
  pointerEvents?: string;
  zIndex?: number;
}

/* Components */

class OverlayComponent extends React.Component<OverlayComponentProps> {
  el: Element | null = null;

  componentDidMount() {
    this.el = document.querySelector(OverlayPortalTargetSelector);
    this.forceUpdate();
  }

  close = (): void => {
    const { close } = this.props;
    close && close();
  };

  render(): React.ReactPortal {
    const { children, closeOnClick, backgroundColor, zIndex, pointerEvents } = this.props;

    if (!this.el) {
      return null;
    }

    return ReactDOM.createPortal(
      <Overlay
        backgroundColor={backgroundColor}
        onClick={closeOnClick ? this.close : undefined}
        pointerEvents={pointerEvents}
        zIndex={zIndex}
      >
        {children}
      </Overlay>,
      this.el
    );
  }
}

export default OverlayComponent;
